import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Home from './pages/Home';
import Services from './pages/Services';
import Prices from './pages/Prices';
import About from './pages/About';
import Contact from './pages/Contact';
import Terms from './pages/Terms';
import Paid from './pages/Paid';
import Booked from './pages/Booked';
import Admin from './pages/Admin';
import AdminCalendar from './pages/AdminCalendar';
import AdminReports from './pages/AdminReports';
import AdminPorters from './pages/AdminPorters';
import AdminStaff from './pages/AdminStaff';
import AdminTomorrow from './pages/AdminTomorrow';
import AdminRegister from './pages/AdminRegister';
import AdminProfit from './pages/AdminProfit';
import Driver from './pages/Driver';
import ResetPassword from './pages/ResetPassword';
import Cancel from './pages/Cancel';
import Reschedule from './pages/Reschedule';
import { AuthProvider } from './auth/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import TopBar from './components/TopBar';
import WhatsAppFab from './components/WhatsAppFab';
import { AnalyticsManager, CookieBanner } from './components/CookieConsent';
import { CookiesPage, PrivacyPage } from './pages/Legal';
import FlyTipping from './pages/FlyTipping';
import { MobileActions } from './components/MobileActions';

const TITLES = {
  '/': 'Move Van Ltd | Removals, Man and Van & Clearances in London',
  '/services': 'Removals, Man and Van, Furniture Delivery & Clearances | Move Van Ltd',
  '/prices': 'Man and Van & Removal Prices | Move Van Ltd',
  '/about': 'About Move Van Ltd | London Removals & Clearances',
  '/contact': 'Contact Move Van Ltd | Removals Enquiries',
  '/terms': 'Terms & Conditions | Move Van Ltd',
  '/privacy': 'Privacy Policy | Move Van Ltd',
  '/cookies': 'Cookies | Move Van Ltd',
  '/fly-tipping': 'How to Report Fly-Tipping Safely | Move Van Ltd',
};
const TitleManager = () => {
  const { pathname } = useLocation();
  useEffect(() => { document.title = TITLES[pathname] || 'Move Van Ltd'; }, [pathname]);
  return null;
};

// Scrolls to a #hash target, or to the top on plain navigation
const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const tryScroll = () => {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return true;
        }
        return false;
      };
      // Wait a frame for the page to mount
      if (!tryScroll()) {
        setTimeout(tryScroll, 60);
        setTimeout(tryScroll, 200);
      }
    } else {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollManager />
          <AnalyticsManager />
          <TitleManager />
          <TopBar />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/prices" element={<Prices />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/cookies" element={<CookiesPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/fly-tipping" element={<FlyTipping />} />
            <Route path="/paid" element={<Paid />} />
            <Route path="/booked" element={<Booked />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/calendar" element={<AdminCalendar />} />
            <Route path="/admin/reports" element={<AdminReports />} />
            <Route path="/admin/porters" element={<AdminPorters />} />
            <Route path="/admin/staff" element={<AdminStaff />} />
            <Route path="/admin/tomorrow" element={<AdminTomorrow />} />
            <Route path="/admin/register" element={<AdminRegister />} />
            <Route path="/admin/profit" element={<AdminProfit />} />
            <Route path="/driver" element={<Driver />} />
            <Route path="/reset" element={<ResetPassword />} />
            <Route path="/cancel/:id" element={<Cancel />} />
            <Route path="/reschedule/:id" element={<Reschedule />} />
          </Routes>
          <Footer />
          <WhatsAppFab />
          <MobileActions />
          <CookieBanner />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
